import { createSlice } from '@reduxjs/toolkit';
import { FlowState } from '../../../types/flow';

const INITIAL_STATE: FlowState = {
  steps: [],
  currentStep: -1,
  nextStepPath: '',
  prevStepPath: '',
  originPath: '',
  currentFlow: undefined,
};

const flowSlice = createSlice({
  name: 'flow',
  initialState: INITIAL_STATE,
  reducers: {
    setSteps: (state, action) => {
      state.steps = action.payload;
    },
    setCurrentStep: (state, action) => {
      const currentStepNum = action.payload;
      state.currentStep = currentStepNum;
      const nextStepNum = currentStepNum + 1;
      const prevStepNum = currentStepNum - 1;
      if (nextStepNum <= state.steps.length + 1) {
        state.nextStepPath = state.steps[nextStepNum - 1]?.key ?? '';
      } else {
        state.nextStepPath = '';
      }
      if (prevStepNum >= 0) {
        state.prevStepPath = state.steps[prevStepNum - 1]?.key ?? '';
      } else {
        state.prevStepPath = '';
      }
    },
    setStepCompletedStatus: (state, action) => {
      const { stepNum, status } = action.payload;
      const steps = [...state.steps];
      const foundStep = steps.find((step) => step?.stepNum === stepNum);
      const stepIndex = foundStep !== undefined ? steps.indexOf(foundStep) : -1;
      if (!isNaN(stepIndex) && stepIndex !== -1) {
        steps[stepIndex].isCompleted = status;
      }
      state.steps = [...steps];
    },
    goToNextStep: (state) => {
      const currentStep = state.currentStep;
      const steps = [...state.steps];
      const foundStep = steps.find((step) => step?.stepNum === currentStep);
      const stepIndex = foundStep !== undefined ? steps.indexOf(foundStep) : -1;
      if (!isNaN(stepIndex) && stepIndex !== -1) {
        steps[stepIndex].isCompleted = true;
      }

      state.currentStep = state.currentStep + 1;
      const nextStepNum = currentStep + 1;
      const prevStepNum = currentStep - 1;
      if (nextStepNum <= state.steps.length + 1) {
        state.nextStepPath = state.steps[nextStepNum - 1]?.key ?? '';
      } else {
        state.nextStepPath = '';
      }
      if (prevStepNum >= 0) {
        state.prevStepPath = state.steps[prevStepNum - 1]?.key ?? '';
      } else {
        state.prevStepPath = '';
      }
      state.steps = steps;
    },
    goToPreviousStep: (state) => {
      const currentStep = state.currentStep;
      const steps = [...state.steps];
      const foundStep = steps.find((step) => step?.stepNum === currentStep);
      const stepIndex = foundStep !== undefined ? steps.indexOf(foundStep) : -1;
      if (!isNaN(stepIndex) && stepIndex !== -1) {
        steps[stepIndex].isCompleted = true;
      }
      state.currentStep = state.currentStep - 1;
      const nextStepNum = currentStep;
      const prevStepNum = currentStep - 2 >= 0 ? currentStep - 2 : 0;
      state.nextStepPath = state.steps[nextStepNum]?.key;
      state.prevStepPath =
        state.steps[prevStepNum - 1 >= 0 ? prevStepNum - 1 : 0]?.key ?? '';
      state.steps = steps;
    },
    setOriginPath: (state, action) => {
      state.originPath = action.payload;
    },
    resetStepState: () => INITIAL_STATE,
    setCurrentFlow: (state, action) => ({
      ...state,
      currentFlow: action.payload,
    }),
  },
});

export const {
  goToNextStep,
  goToPreviousStep,
  setSteps,
  setCurrentStep,
  setStepCompletedStatus,
  setOriginPath,
  resetStepState,
  setCurrentFlow,
} = flowSlice.actions;

export default flowSlice.reducer;
